import { useEffect, useState } from 'react';
import './Giveaway.css';
import './TwitchAccount.css';

export default function TwitchAccount() {
  const [twitchUsername, setTwitchUsername] = useState('');
  const [twitchUserInfo, setTwitchUserInfo] = useState(null);
  const [twitchLoading, setTwitchLoading] = useState(false);
  const [twitchError, setTwitchError] = useState('');

  useEffect(() => {
    const savedToken = localStorage.getItem('twitch_token');
    const savedUser = localStorage.getItem('twitch_username');
    if (savedToken && savedUser) {
      setTwitchUsername(savedUser);
      fetchTwitchUserInfo(savedToken);
    }
  }, []);

  const fetchTwitchUserInfo = async (token) => {
    setTwitchLoading(true);
    setTwitchError('');
    try {
      const res = await fetch(`/api/twitch/user-info?token=${encodeURIComponent(token)}`);
      const data = await res.json();
      console.log('[TWITCH] user-info:', data);
      if (data && data.login) {
        setTwitchUserInfo(data);
      } else if (data && data.error === 'no_token') {
        setTwitchError('Kein Twitch-Token vorhanden. Bitte einloggen.');
      } else if (data && data.error === 'user_not_found') {
        setTwitchError('Twitch-Benutzer nicht gefunden.');
      } else {
        setTwitchError('Twitch-Daten konnten nicht geladen werden.');
      }
    } catch (e) {
      console.error('[TWITCH] fetch error:', e);
      setTwitchError('Verbindungsfehler zu Twitch.');
    }
    setTwitchLoading(false);
  };

  const handleTwitchLogin = () => {
    window.location.href = '/api/twitch/auth';
  };

  const handleDisconnectTwitch = () => {
    localStorage.removeItem('twitch_token');
    localStorage.removeItem('twitch_username');
    localStorage.removeItem('twitch_display_name');
    setTwitchUsername('');
    setTwitchUserInfo(null);
  };

  return (
    <div className="page twitch-account-page">
      <h1>📊 Account Info</h1>
      {twitchUsername ? (
        <>
          <div className="giveaway-twitch-connected">
            <span>✅ Twitch verbunden: <strong>{twitchUsername}</strong></span>
            <button className="giveaway-btn-twitch" onClick={handleDisconnectTwitch}>
              Trennen
            </button>
          </div>
          {twitchLoading ? (
            <div className="giveaway-twitch-loading">Twitch-Daten werden geladen...</div>
          ) : twitchError ? (
            <div className="giveaway-twitch-error">⚠️ {twitchError} <button className="giveaway-btn-twitch" onClick={handleTwitchLogin} style={{marginLeft: 8}}>Erneut einloggen</button></div>
          ) : twitchUserInfo ? (
            <div className="giveaway-twitch-card">
              <h3>📊 Dein Twitch-Account</h3>
              <div className="giveaway-twitch-stats">
                <div className="giveaway-stat">
                  <span className="giveaway-stat-value">{twitchUserInfo.viewCount ? Number(twitchUserInfo.viewCount).toLocaleString() : twitchUserInfo.viewCount}</span>
                  <span className="giveaway-stat-label">Zuschauer</span>
                </div>
                <div className="giveaway-stat">
                  <span className="giveaway-stat-value">{twitchUserInfo.followers ? Number(twitchUserInfo.followers).toLocaleString() : twitchUserInfo.followers}</span>
                  <span className="giveaway-stat-label">Follower</span>
                </div>
                <div className="giveaway-stat">
                  <span className="giveaway-stat-value">{twitchUserInfo.broadcasterType}</span>
                  <span className="giveaway-stat-label">Typ</span>
                </div>
              </div>
              {twitchUserInfo.displayName && (
                <p className="giveaway-twitch-hint">
                  Streamer-Name <strong>{twitchUserInfo.displayName}</strong>
                </p>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <div className="giveaway-twitch-not-connected">
          <p>🔑 Du bist noch nicht mit Twitch verbunden. Verbinde deinen Account.</p>
          <button className="giveaway-btn-twitch" onClick={handleTwitchLogin}>
            🔗 Mit Twitch einloggen
          </button>
        </div>
      )}
    </div>
  );
}
